import { render } from "./X.vue?vue&type=template&id=3de95d4c&scoped=true"
import script from "./X.vue?vue&type=script&setup=true&lang=js"
export * from "./X.vue?vue&type=script&setup=true&lang=js"

import "./X.vue?vue&type=style&index=0&id=3de95d4c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de95d4c"],['__file',"src/icons/X.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3de95d4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3de95d4c', __exports__)) {
    api.reload('3de95d4c', __exports__)
  }
  
  module.hot.accept("./X.vue?vue&type=template&id=3de95d4c&scoped=true", () => {
    api.rerender('3de95d4c', render)
  })

}


export default __exports__